import { cloneDeep } from 'lodash';
import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { labelToSectionId } from '../NPOFeedback/utils';
import { ReportStage } from 'donor/portal/pages/FeedbackDashboard/api';

export interface NavOption {
  id: number;
  text: string;
  focus: boolean;
  valid: boolean;
  error: boolean;
  warning: boolean;
}

export interface NavSection {
  id: number;
  title: string;
  sub: string;
  focus: boolean;
  options: NavOption[];
}

const NARRATIVE_OPTION = {
  id: 8,
  text: 'Narrative',
  focus: false,
  valid: false,
  error: false,
  warning: false,
};

export const getDeepCloneSections = (
  sections: NavSection[],
  isPassed: boolean,
) => {
  const clonedSections = cloneDeep(sections);

  if (isPassed) {
    const narrativeExists = clonedSections[0].options.some(
      option => option.text === 'Narrative',
    );
    if (!narrativeExists) {
      clonedSections[0].options.splice(7, 0, NARRATIVE_OPTION);
    }
  } else {
    clonedSections[0].options = clonedSections[0].options.filter(
      option => option.text !== 'Narrative',
    );
  }

  return clonedSections;
};

export const INTRO_SECTION_TEXT = 'Intro';
export const SECTIONS: NavSection[] = [
  {
    id: 1,
    title: 'Program Start',
    sub: 'Forecast due 01 Jan 2022 (7 days)',
    focus: false,
    options: [
      // {
      //   id: 0,
      //   text: INTRO_SECTION_TEXT,
      //   focus: false,
      //   valid: false,
      //   error: false,
      //   warning: false,
      // },
      {
        id: 1,
        text: 'Description',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 2,
        text: 'Dates',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 3,
        text: 'Location',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 4,
        text: 'Activities',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 5,
        text: 'Impact Model Builder',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 6,
        text: 'Impact Model Details',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 7,
        text: 'Beneficiaries',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      // {
      //   id: 8,
      //   text: 'Narrative',
      //   focus: false,
      //   valid: false,
      //   error: false,
      //   warning: false,
      // },
      {
        id: 9,
        text: 'Budget',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 10,
        text: 'Review & Submit',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      // {
      //   id: 11,
      //   text: 'Address Feedback',
      //   focus: false,
      //   valid: false,
      //   error: false,
      //   warning: false,
      // },
    ],
  },
  {
    id: 2,
    title: 'Program Midpoint',
    sub: 'Due 15 Jun 2022 (180 days)',
    focus: false,
    options: [
      {
        id: 1,
        text: 'Program Overview',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 2,
        text: 'Interim Forecasts',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 3,
        text: 'Beneficiaries',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 4,
        text: 'Progress Notes',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 5,
        text: 'Budget',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 6,
        text: 'Review & Submit',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
    ],
  },
  {
    id: 3,
    title: 'Program End',
    sub: 'Due 31 Dec 2022 (345 days)',
    focus: false,
    options: [
      {
        id: 1,
        text: 'Program Overview',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 2,
        text: 'Final Results',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 3,
        text: 'Beneficiaries',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 4,
        text: 'Narrative',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 5,
        text: 'Budget',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
      {
        id: 6,
        text: 'Review & Submit',
        focus: false,
        valid: false,
        error: false,
        warning: false,
      },
    ],
  },
];

export const FINAL_REPORT_SECTIONS = () => {
  const result: NavSection[] = cloneDeep(SECTIONS);
  const resultOptions: NavOption[] = [];
  for (const o of SECTIONS[0].options) {
    resultOptions.push(o);
    if (o.id === 7) {
      resultOptions.push(NARRATIVE_OPTION);
    }
  }
  result[0].options = resultOptions;
  return result;
};

export const INTERIM_REPORT_SECTIONS = () => {
  const result: NavSection[] = cloneDeep(SECTIONS);
  return result;
};

export const getSection = (
  sectionId: FeedbackSectionId,
  sections: typeof SECTIONS = SECTIONS,
  stageNumber = 0,
) => {
  const index = sections[stageNumber].options.findIndex(
    x => labelToSectionId(x.text) === sectionId,
  );
  if (index === -1) return undefined;
  return {
    index,
    option: sections[stageNumber].options[index],
  };
};

export const MULTI_RADIO_OPTIONS = [
  { id: 1, text: 'Lorem ipsum dolor sit amet', checked: true },
  { id: 2, text: 'Consectetur adipiscing elit', checked: false },
  {
    id: 3,
    text: 'Excepteur sint occaecat cupidatat non proident',
    checked: false,
  },
  { id: 4, text: 'Sed ut perspiciatis unde omnis iste natus', checked: false },
];

export const SECTION_IDS = {
  description: 1,
  dates: 2,
  location: 3,
  activities: 3,
  impactSummary: 5,
  impactDetails: 6,
  beneficiaries: 7,
  narrative: 8,
};

export const SECTION_FILTER = {
  Description: 'description',
  Dates: 'dates',
  Location: 'location',
  Activities: 'activities',
  'Impact Model Builder': 'impact_summary',
  'Impact Model Details': 'indicator_details',
  Beneficiaries: 'beneficiaries',
  Narrative: 'narrative',
  Budget: 'budget',
  'Program Overview': 'interim_report',
  'Program Notes': 'interim_report',
  'Final Results': 'finalize_report',
  'Interim Forecasts': 'interim_report',
  'Review & Submit': 'finalize_report',
  // 'Address Feedback': 'address_feedback',
  'Progress Notes': 'interim_report',
};

export const EXTRA_REQUIREMENTS = {
  request_fiscal_year_date: 'request_fiscal_year_date',
};

// Optional "notes (+ optional file)" questions appended to their sections (TIPD-3323).
// These IDs must match the npo_report_question rows inserted for each section.
export const NOTE_QUESTION_IDS = {
  activities: 110050,
  impactDetails: 50050,
  beneficiaries: 60050,
};

export const NOTE_QUESTION_ID_LIST = Object.values(NOTE_QUESTION_IDS);

export const MEASURE_IDS = {
  EA1:
    'Estimate based on successful program completion (but without specific measurement of behavior change)',
  EA2:
    'Estimate based on resulting behavior change measured by a different but similar program',
  EA3:
    'Estimate based on resulting behavior change from published studies of similar programs',
  EA4:
    'Estimate based on resulting behavior change measured for this program in the past (but which is not currently measured)',
  EA5: 'Estimate of behavior change based on government data',
  EA99: 'Other estimate of behavior change [please describe in next step]',
  EC1:
    'Estimate based on successful program completion (but without specific measurement of program development gains)',
  EC2:
    'Estimate based on program development gains measured by a different but similar program',
  EC3:
    'Estimate based on program development gains from published studies of similar programs',
  EC4:
    'Estimate based on program development gains measured for this program in the past (but which is not currently measured)',
  EC5: 'Estimate of program development  gains based on government data',
  EC99:
    'Other estimate of program development gains [please describe in next step]',
  EL1:
    'Estimate based on successful program completion (but without specific measurement of learning gains)',
  EL2:
    'Estimate based on learning gains measured by a different but similar program',
  EL3:
    'Estimate based on learning gains from published studies of similar programs',
  EL4:
    'Estimate based on learning gains measured for this program in the past (but which is not currently measured)',
  EL5: 'Estimate of learning gains based on government data',
  EL99: 'Other estimate of learning gains [please describe in next step]',
  ER2:
    'Estimate based on reach data measured by a different but similar program',
  ER3:
    'Estimate based on reach data from published studies of similar programs',
  ER4:
    'Estimate based on reach data measured for this program in the past (but which is not currently measured)',
  ER5: 'Estimate of reach based on government data',
  ER99: 'Other estimate of reach [please describe in next step]',
  ES1:
    'Estimate based on successful program completion (but without specific measurement of social impact)',
  ES2:
    'Estimate based on social impact measured by a different but similar program',
  ES3:
    'Estimate based on social impact from published studies of similar programs',
  ES4:
    'Estimate based on social impact measured for this program in the past (but which is not currently measured)',
  ES5: 'Estimate of social impact change based on government data',
  ES99: 'Other estimate of social impact [please describe in next step]',
  G1: 'Guess based on logic, intuition, or speculation',
  G2:
    'Guess based on anecdotal results (success stories, personal experiences)',
  G3: 'Guess based on knowledge, experience in this field',
  G99: 'Guess based on other [please describe in next step]',
  MA3:
    'Anticipated actions or behavior change self-reported by [intermediaries] (i.e., their expectations for the future)',
  MA4:
    'Subjective assessment of actual behavior change self-reported by [intermediaries] (based on their own opinion)',
  MA5:
    'Subjective assessment of actual behavior change reported by program implementers (based on their own opinion)',
  MA6:
    'Objective assessment of actual behavior change self-reported by [intermediaries] (e.g., based on surveys or tests using ' +
      'specific, predefined evaluation criteria)',
  MA7:
    'Objective assessment of actual behavior change reported by program implementers (e.g., based on surveys or tests using ' +
      'specific, predefined evaluation criteria)',
  MA99:
    'Other direct measurement of behavior change [please describe in next step]',
  MC4:
    'Subjective assessment of program development gains self-reported by recipients (based on their own opinion)',
  MC5:
    'Subjective assessment of program development gains self-reported by program implementers (based on their own opinion)',
  MC6:
    'Objective assessment of program development gains self-reported by recipients (e.g., based on surveys or tests using specific, ' +
      'predefined evaluation criteria)',
  MC7:
    'Objective assessment of program development gains reported by program implementers (e.g., based on surveys or tests using ' +
      'specific, predefined evaluation criteria)',
  MC99:
    'Other direct measurement of capacity gains [please describe in next step]',
  ML4:
    'Subjective assessment of learning gains self-reported by [intermediaries] (based on their own opinion)',
  ML5:
    'Subjective assessment of learning gains reported by program implementers (based on their own opinion)',
  ML6:
    'Objective assessment of learning gains self-reported by [intermediaries] (e.g., based on surveys or tests using specific, ' +
      'predefined evaluation criteria)',
  ML7:
    'Objective assessment of learning gains reported by program implementers (e.g., based on surveys or tests using specific, ' +
      'predefined evaluation criteria)',
  ML99:
    'Other direct measurement of learning gains [please describe in next step]',
  MR1: 'Tracked by participant sign-in, attendance lists, or usage logs',
  MR2: 'Derived from other tracked data (e.g., sales, member lists)',
  MR99: 'Other direct measurement of reach [please describe in next step]',
  MS4:
    'Subjective assessment of social impact self-reported by [beneficiaries] (based on their own opinion)',
  MS5:
    'Subjective assessment of social impact reported by program implementers (based on their own opinion)',
  MS6:
    'Objective assessment of social impact self-reported by [beneficiaries] (e.g., based on surveys or tests using specific, ' +
      'predefined evaluation criteria)',
  MS7:
    'Objective assessment of social impact reported by program implementers (e.g., based on surveys or tests using specific, ' +
      'predefined evaluation criteria',
  MS99:
    'Other direct measurement of social impact [please describe in next step]',
};

export const CLASSIFICATIONS_CAPACITY = [
  {
    ids: [{ category: 'All', list: ['G1', 'G2', 'G3', 'G99'] }],
    label: 'Guess',
  },
  {
    ids: [
      {
        category: 'Capacity Developed',
        list: ['EC1', 'EC2', 'EC3', 'EC4', 'EC5', 'EC99'],
      },
    ],
    label: 'Estimate',
  },
  {
    ids: [
      {
        category: 'Capacity Developed',
        list: ['MC4', 'MC5', 'MC6', 'MC7', 'MC99'],
      },
    ],
    label: 'Measured',
  },
];

export const CLASSIFICATIONS_REACH = [
  {
    ids: [{ category: 'All', list: ['G1', 'G2', 'G3', 'G99'] }],
    label: 'Guess',
  },
  {
    ids: [{ category: 'Reached', list: ['ER2', 'ER3', 'ER4', 'ER5', 'ER99'] }],
    label: 'Estimate',
  },
  {
    ids: [{ category: 'Reached', list: ['MR1', 'MR2', 'MR99'] }],
    label: 'Measured',
  },
];

export const CLASSIFICATIONS_LEARN = [
  {
    ids: [{ category: 'All', list: ['G1', 'G2', 'G3', 'G99'] }],
    label: 'Guess',
  },
  {
    ids: [
      { category: 'Learn', list: ['EL1', 'EL2', 'EL3', 'EL4', 'EL5', 'EL99'] },
    ],
    label: 'Estimate',
  },
  {
    ids: [{ category: 'Learn', list: ['ML4', 'ML5', 'ML6', 'ML7', 'ML99'] }],
    label: 'Measured',
  },
];

export const CLASSIFICATIONS_ACT = [
  {
    ids: [{ category: 'All', list: ['G1', 'G2', 'G3', 'G99'] }],
    label: 'Guess',
  },
  {
    ids: [
      {
        category: 'Mobilized',
        list: ['EA1', 'EA2', 'EA3', 'EA4', 'EA5', 'EA99'],
      },
    ],
    label: 'Estimate',
  },
  {
    ids: [
      {
        category: 'Mobilized',
        list: ['MA3', 'MA4', 'MA5', 'MA6', 'MA7', 'MA99'],
      },
    ],
    label: 'Measured',
  },
];

export const CLASSIFICATIONS_SOCIAL = [
  {
    ids: [{ category: 'All', list: ['G1', 'G2', 'G3', 'G99'] }],
    label: 'Guess',
  },
  {
    ids: [
      {
        category: 'Social Impact',
        list: ['ES1', 'ES2', 'ES3', 'ES4', 'ES5', 'ES99'],
      },
    ],
    label: 'Estimate',
  },
  {
    ids: [
      { category: 'Social Impact', list: ['MS4', 'MS5', 'MS6', 'MS7', 'MS99'] },
    ],
    label: 'Measured',
  },
];

export const CLASSIFICATIONS_CATALIZED = [
  {
    ids: [{ category: 'All', list: ['G1', 'G2', 'G3', 'G99'] }],
    label: 'Guess',
  },
  {
    ids: [
      {
        category: 'Catalyzed',
        list: ['ES1', 'ES2', 'ES3', 'ES4', 'ES5', 'ES99'],
      },
    ],
    label: 'Estimate',
  },
  {
    ids: [
      { category: 'Catalyzed', list: ['MS4', 'MS5', 'MS6', 'MS7', 'MS99'] },
    ],
    label: 'Measured',
  },
];

export const ENUM_TYPES = {
  FILE: 'file',
};
